import React, { useState, SetStateAction, useEffect } from 'react';
import { Grid, Typography, Box, InputLabel, Select, MenuItem } from '@material-ui/core';
import { useStyles } from './styles';
import { MissionDetails } from '../../@types/records';
import { suportTeam } from '../../pages/AddSurveillance/utils';
import SubInputWarn from '../SubInputWarn';

interface IProps {
  missionDetails: MissionDetails;
  setMissioDetails: React.Dispatch<SetStateAction<MissionDetails>>;
  formErrors: { key: string; message: string }[];
}

const MissionDetailsForm: React.FC<IProps> = ({
  missionDetails,
  setMissioDetails,
  formErrors,
}) => {
  const classes = useStyles();
  const [detailsState, setDetailsState] = useState<MissionDetails>(missionDetails);
  const [errors, setErrors] = useState<{ key: string; message: string }[]>([]);

  const handleChange = (key: string, value: string) => {
    if (key !== 'Equipe de Apoio') {
      setDetailsState({ ...missionDetails, [key]: value });
    }
    setDetailsState((prev) => {
      const total =
        Number(prev['Quantidade de Motocicletas, Ciclomotores e Triciclos Abordados']) +
        Number(prev['Quantidade de Veículos com mais de 3 Rodas Abordados']);

      return {
        ...missionDetails,
        [key]: value,
        'Total de Veículos Abordados': total.toString(),
      };
    });
  };

  useEffect(() => {
    setDetailsState(missionDetails);
    const vehiclesErrors = formErrors.filter((item) => {
      return item.key === 'removedVehicles';
    });

    setErrors(vehiclesErrors);
  }, [formErrors, missionDetails]);
  return (
    <Box className={classes.sectionContainer}>
      <Typography variant="h6">Detalhes da Missão</Typography>
      <Grid container xl={12} spacing={2}>
        <Grid item xs={12} md={6}>
          <InputLabel className={classes.label}>Equipe de Apoio</InputLabel>
          <Select
            variant="outlined"
            className={classes.select}
            value={detailsState['Equipe de Apoio']}
            onChange={(event) => {
              handleChange('Equipe de Apoio', event.target.value as string);
            }}
            onBlur={() => setMissioDetails(detailsState)}
          >
            {suportTeam.map((item) => (
              <MenuItem value={item} key={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          <InputLabel className={classes.label}>
            Qtd. de Veículos com 4 Rodas ou mais abordados
          </InputLabel>
          <input
            name="Descrição do Tipo da Missão"
            type="number"
            min={0}
            className={classes.input}
            value={detailsState['Quantidade de Veículos com mais de 3 Rodas Abordados']}
            onChange={(event) => {
              handleChange(
                'Quantidade de Veículos com mais de 3 Rodas Abordados',
                event.target.value,
              );
            }}
            onBlur={() => setMissioDetails(detailsState)}
          />
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          <InputLabel className={classes.label}>
            Qtd. de Motocicletas, Ciclomotores e Triciclos abordados
          </InputLabel>
          <input
            name="Quantidade de Motocicletas, Ciclomotores e Triciclos Abordados"
            type="number"
            min={0}
            className={classes.input}
            value={
              detailsState[
                'Quantidade de Motocicletas, Ciclomotores e Triciclos Abordados'
              ]
            }
            onChange={(event) => {
              handleChange(
                'Quantidade de Motocicletas, Ciclomotores e Triciclos Abordados',
                event.target.value,
              );
            }}
            onBlur={() => setMissioDetails(detailsState)}
          />
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          <InputLabel className={classes.label} error={!!errors.length}>
            Qtd. de Veículos 4 ou mais Rodas Removidos (Pela AMC ou pelo Proprietário)
          </InputLabel>
          <input
            name="Quantidade de Veículos 4+ Rodas Removidos (Pela AMC ou pelo Proprietário)"
            type="number"
            min={0}
            className={`${classes.input} ${errors.length ? classes.errorIput : ''}`}
            value={
              detailsState[
                'Quantidade de Veículos 4+ Rodas Removidos (Pela AMC ou pelo Proprietário)'
              ]
            }
            onChange={(event) => {
              handleChange(
                'Quantidade de Veículos 4+ Rodas Removidos (Pela AMC ou pelo Proprietário)',
                event.target.value,
              );
            }}
            onBlur={() => setMissioDetails(detailsState)}
          />
          <SubInputWarn
            type="error"
            formWarns={errors.filter((item) => item.key === 'removedVehicles')}
          />
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          <InputLabel className={classes.label} error={!!errors.length}>
            Qtd. de Motocicletas, Ciclomotores e Tricículos Removidos (Pela AMC ou pelo
            Proprietário)
          </InputLabel>
          <input
            name="Quantidade de Veículos de 2 ou 3 Rodas Removidos (Pela AMC ou pelo Proprietário)"
            type="number"
            min={0}
            className={`${classes.input} ${errors.length ? classes.errorIput : ''}`}
            value={
              detailsState[
                'Quantidade de Veículos de 2 ou 3 Rodas Removidos (Pela AMC ou pelo Proprietário)'
              ]
            }
            onChange={(event) => {
              handleChange(
                'Quantidade de Veículos de 2 ou 3 Rodas Removidos (Pela AMC ou pelo Proprietário)',
                event.target.value,
              );
            }}
            onBlur={() => setMissioDetails(detailsState)}
          />
          <SubInputWarn
            type="error"
            formWarns={errors.filter((item) => item.key === 'removedVehicles')}
          />
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          <InputLabel className={classes.label}>Qtd. de CRLVs Recolhidos</InputLabel>
          <input
            name="Quantidade de CRLVs Recolhidos"
            type="number"
            min={0}
            className={classes.input}
            value={detailsState['Quantidade de CRLVs Recolhidos']}
            onChange={(event) => {
              handleChange('Quantidade de CRLVs Recolhidos', event.target.value);
            }}
            onBlur={() => setMissioDetails(detailsState)}
          />
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          <InputLabel className={classes.label}>Total de Veículos Abordados</InputLabel>
          <input
            name="Total de Veículos Abordados"
            type="number"
            readOnly
            className={classes.input}
            min={missionDetails['Total de Veículos Abordados']}
            value={missionDetails['Total de Veículos Abordados']}
          />
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          <InputLabel className={classes.label}>
            Qtd. de Habilitações Recolhidas
          </InputLabel>
          <input
            name="Quantidade de Habilitações Recolhidas"
            type="number"
            min={0}
            className={classes.input}
            value={detailsState['Quantidade de Habilitações Recolhidas']}
            onChange={(event) => {
              handleChange('Quantidade de Habilitações Recolhidas', event.target.value);
            }}
            onBlur={() => setMissioDetails(detailsState)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MissionDetailsForm;
